import { useCallback, useMemo } from 'react';
import { useParams } from 'quartz-routing/react-router';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import LanguageIcon from 'unsubscribe-ui/components/core/icons/LanguageIcon';
import Flex from 'unsubscribe-ui/components/core/layout/Flex';
import Select from 'unsubscribe-ui/components/core/Select';
import { trackLanguageChange } from 'unsubscribe-ui/data/TrackingEvents';
import { redirectToUrl } from 'unsubscribe-ui/utils/common';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getNewLangRedirectURL = (langCode, url) => {
  const currentUrl = new URL(url);

  //TODO: Merge Regex later
  if (currentUrl.pathname.includes('/hs/email-subscriptions')) {
    currentUrl.pathname = currentUrl.pathname.replace(/\b(?!preferences)\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)\//, `/${langCode}/`);
    return currentUrl;
  }
  currentUrl.pathname = currentUrl.pathname.replace(/\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?)\//, `/${langCode}/`);
  return currentUrl;
};
const LanguageSelectorComponent = ({
  availableLanguageCodes
}) => {
  const {
    language
  } = useParams();
  const hasUrlLanguage = useMemo(() => availableLanguageCodes.includes(language), [availableLanguageCodes, language]);
  const handleLanguageSelectChange = useCallback(lang => {
    trackLanguageChange(lang);
    const currentUrl = getNewLangRedirectURL(lang, window.location.href);
    redirectToUrl(currentUrl.toString());
  }, []);
  const options = useMemo(() => availableLanguageCodes.map(languageCode => ({
    value: languageCode,
    label: LanguageNames[languageCode]
  })), [availableLanguageCodes]);
  return /*#__PURE__*/_jsxs(Flex, {
    align: "center",
    justify: "left",
    textAlign: "left",
    direction: "row",
    children: [/*#__PURE__*/_jsx(LanguageIcon, {}), /*#__PURE__*/_jsx(Select, {
      value: hasUrlLanguage ? language : '',
      onChange: handleLanguageSelectChange,
      options: options,
      "data-test-id": "language-select-dropdown"
    })]
  });
};
export default function LanguageSelector({
  availableLanguageCodes
}) {
  if (!availableLanguageCodes || availableLanguageCodes && availableLanguageCodes.length <= 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(LanguageSelectorComponent, {
    availableLanguageCodes: availableLanguageCodes
  });
}